import React from 'react';

import Image from 'next/image';
import Link from 'next/link';

import { styles } from '.';

type TProps = {
  logoUrl?: string;
  locale: string;
};

const LogoSection = (props: TProps) => {
  const { logoUrl, locale } = props;

  return (
    <div className={styles.container}>
      <div className="relative w-[6rem] sm:w-[8rem] h-[4rem]">
        <Link href={`/${locale}`}>
          <Image src={logoUrl ?? ''} alt="logo" className="object-fit" fill />
        </Link>
      </div>
    </div>
  );
};

export default LogoSection;
